import { useEffect, useCallback } from "react";
import { useParameter, useSubscriptionProviderContext } from "../../../shared";

import { useSlideTitle } from "../hooks/useSlideTitle";
import { ApplyParameters } from "../../../shared/components/SubscriptionProvider/SubscriptionProvider.types";

const CALENDAR_STEP = 10000;

export function useSubscription() {
  const title = useSlideTitle();
  const subtitle = "";
  const {
    actions: { setParameters, setTitle, setSubtitle, setApplyParametersFunction },
  } = useSubscriptionProviderContext();

  const [countries] = useParameter<number[]>("@countries");
  const [calendar] = useParameter<number>("@calendar");
  const [countriesDisplay] = useParameter<number[]>("@countries_display");

  const [business, setBusiness] = useParameter<number>("@business-units");
  const [commodities, setCommodities] = useParameter<number>("@commodities");
  const [commodityDisplay, setCommodityDisplay] = useParameter<number>("@commodities_display");

  useEffect(() => {
    setTitle(title);
    setSubtitle(subtitle);
    setParameters({
      "@commodities": commodities,
      "@commodities_display": commodityDisplay,
      "@countries": countries,
      "@countries_display": countriesDisplay,
      "@business-units": business,
      "@calendar": calendar,
      "@xlsx_calendar": [-5, -4, -3, -2, -1, 0].map((x) => String((calendar || 0) + x * CALENDAR_STEP)),
    });
  }, [title, subtitle, business, commodityDisplay, calendar, commodities, countriesDisplay, countries, setParameters]);

  const applyParameters = useCallback(
    (parameters: ApplyParameters) => {
      setBusiness((parameters["@business-units"].value as string[]).map(Number)[0]);
      setCommodities((parameters["@commodities"].value as string[]).map(Number)[0]);
      setCommodityDisplay((parameters["@commodities_display"].value as string[]).map(Number)[0]);
    },
    [setBusiness, setCommodities, setCommodityDisplay]
  );

  useEffect(() => {
    setApplyParametersFunction(applyParameters);
  }, [setApplyParametersFunction, applyParameters]);
}
